import apiHandler from '../core/apiHandler';

/**
 * API base del Evento de Retorno.
 *
 * Backend:
 * /api/dte/sales/return
 */
const returnApi = apiHandler('dte/sales/return');

export default returnApi;